import { render, staticRenderFns } from "./BlanketVOBAsInquiry.vue?vue&type=template&id=6cc46ab4&scoped=true"
import script from "./BlanketVOBAsInquiry.vue?vue&type=script&lang=js"
export * from "./BlanketVOBAsInquiry.vue?vue&type=script&lang=js"
import style0 from "./BlanketVOBAsInquiry.vue?vue&type=style&index=0&id=6cc46ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc46ab4",
  null
  
)

export default component.exports